import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import { EditServiceImageD } from "../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";

export default function ServiceImageEdit({
  serviceEdit,
  serviceInfoImgId: serviceInfoId,
  setServiceEdit,
}) {
  const [mainPhoto, setMainPhoto] = useState("");
  const [photoFile, setPhotoFile] = useState();
  const [details, setDetails] = useState("");
  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setMainPhoto(reader.result);
    };
    setPhotoFile(file);
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const data = useSelector(
    (state) => state.main.data?.servicesImagesData
  )?.filter((item) => item.id == serviceInfoId)?.[0];
  const EditServiceImage = () => {
    dispatch(EditServiceImageD({ details, photoFile, id: serviceInfoId }));
    setMainPhoto("");
    setDetails("");
    toast.info("Editing Service Image...", { autoClose: false });
    setServiceEdit(false);
  };
  return (
    serviceEdit && (
      <div className="service-images-edit-action" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setServiceEdit(false)}
        ></div>
        <div className="container ">
          <div className="title">تعديل صوره </div>
          <label
            htmlFor="add-image"
            className={mainPhoto ? `image` : `image none`}
          >
            <img
              src={
                mainPhoto
                  ? `${mainPhoto}`
                  : `https://api.atharalfarasha.com/public/hakim/${data.service_image}`
              }
              alt=""
            />
          </label>
          <input
            type="file"
            onChange={handleFileChange}
            name=""
            accept="image/*"
            id="add-image"
            style={{ display: "none" }}
          />
          <div className="text">
            <textarea
              type="text"
              placeholder="Details Of Image"
              defaultValue={data.service_desc}
              onChange={(e) => setDetails(e.target.value)}
            />
          </div>
          <div className="add-btn" onClick={() => EditServiceImage()}>
            تعديل
          </div>
        </div>
      </div>
    )
  );
}
